import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  seconds: number;
  tone?: 'light' | 'dark';
  compact?: boolean;
};
export function Countdown({
  seconds,
  tone = 'light',
  compact = false
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds: secs
  } = useCountdown(seconds);
  const boxClasses = tone === 'dark' ? 'bg-white/10 text-white' : 'bg-surface-alt text-ink-strong';
  const labelClasses = tone === 'dark' ? 'text-white/60' : 'text-ink-muted';
  const units = [{
    value: hours,
    label: 'Hs'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: secs,
    label: 'Seg'
  }];
  return <div className="flex items-center gap-1.5" role="timer" aria-live="off" data-id="element-35" data-mp="3259gixm3f1sc">
      {units.map(unit => <div key={unit.label} className={`flex flex-col items-center rounded-lg px-2.5 py-1.5 ${boxClasses} ${compact ? 'w-14' : 'w-16'}`} data-id="element-36" data-mp="3731i6jcji29q">
          <span className={`font-display tabular-nums leading-none ${compact ? 'text-xl' : 'text-2xl sm:text-3xl'}`} data-id="element-37" data-mp="15an45vd49hyl">
            {unit.value}
          </span>
          <span className={`mt-1 text-[9px] font-bold uppercase tracking-wide ${labelClasses}`} data-id="element-38" data-mp="szzepffkrem5">
            {unit.label}
          </span>
        </div>)}
    </div>;
}